import { Progress, type ProgressProps } from '@chakra-ui/react'
import { ColorScheme, SizeType } from '@/types';
import React from "react";


interface Props extends ProgressProps {
  colorScheme?: ColorScheme,
  size?: SizeType,
};

const Component = React.forwardRef((props: Props, ref: React.Ref<any>) => {
  return (
    <Progress isAnimated { ...props } />
  )
})


export {
  Component as Progress,
  type Props as ProgressProps,
}